"use client";
import Image from "next/image";
import Flickity from "react-flickity-component";

import "./TeamList.scss";
import { useEffect, useState } from "react";

// const flickityOptions = {
//     initialIndex: window.innerWidth < 768 ? 1 : 0
// }
const TeamList = () => {
  return (
      <Flickity
          className={"team__list"} // default ''
          elementType={"div"}
          options={{cellAlign: "left"}} // takes flickity options {}
          disableImagesLoaded={false} // default false
          reloadOnUpdate // default false
          static // default false
      >
        {/* <div className="team__item ">
        <Image
          className="team__img"
          src="/images/team/team1.jpeg"
          alt="team"
          width={100}
          height={100}
          objectFit="cover"
        />
      </div> */}
        <div className="team__item ">
          <Image
              className="team__img"
              src="/images/team/team1-1.jpg"
              alt="team"
              width={1280}
              height={1280}
          />
        </div>
        <div className="team__item ">
          <Image
              className="team__img"
              src="/images/team/team2-1.jpg"
              alt="team"
              width={1280}
              height={1280}
          />
        </div>
        <div className="team__item ">
          <Image
              className="team__img"
              src="/images/team/team3-1.jpg"
              alt="team"
              width={1280}
              height={1280}
          />
        </div>
        <div className="team__item ">
          <Image
              className="team__img"
              src="/images/team/team4-1.jpg"
              alt="team"
              width={1280}
              height={1280}
          />
        </div>
        <div className="team__item ">
          <Image
              className="team__img"
              src="/images/team/team5-1.jpg"
              alt="team"
              width={1280}
              height={1280}
          />
        </div>
        <div className="team__item ">
          <Image
              className="team__img"
              src="/images/team/team6-1.jpg"
              alt="team"
              width={1280}
              height={1280}
          />
        </div>
        <div className="team__item ">
          <Image
              className="team__img"
              src="/images/team/team7-1.jpg"
              alt="team"
              width={1280}
              height={1280}
          />
        </div>
        <div className="team__item ">
          <Image
              className="team__img"
              src="/images/team/team8-1.jpg"
              alt="team"
              width={1280}
              height={1280}
          />
        </div>
        <div className="team__item ">
          <Image
              className="team__img"
              src="/images/team/team9-1.jpg"
              alt="team"
              width={1280}
              height={1280}
          />
        </div>
        <div className="team__item ">
          <Image
              className="team__img"
              src="/images/team/team10-1.jpg"
              alt="team"
              width={1280}
              height={1280}
          />
        </div>
      </Flickity>
  );
};
export default TeamList;
